export interface MessageModel {
  user: number
  type: 'in' | 'out'
  text: string
  time: string
  template?: boolean
}

const defaultMessages: Array<MessageModel> = [
  {
    user: 4,
    type: 'in',
    text: 'How likely are you to recommend our company to your friends and family ?',
    time: '2 mins',
  },
  {
    user: 2,
    type: 'out',
    text: 'Hey there, we’re just writing to let you know that you’ve been subscribed to a repository on GitHub.',
    time: '5 mins',
  },
  {
    user: 4,
    type: 'in',
    text: 'Ok, Understood!',
    time: '1 Hour',
  },
  {
    user: 2,
    type: 'out',
    text: 'You’ll receive notifications for all issues, pull requests!',
    time: '2 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'You can unwatch this repository immediately by clicking here: <a href="https://keenthemes.com">Keenthemes.com</a>',
    time: '3 Hours',
  },
  {
    user: 2,
    type: 'out',
    text: 'Most purchased Business courses during this sale!',
    time: '4 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'Company BBQ to celebrate the last quater achievements and goals. Food and drinks provided',
    time: '5 Hours',
  },
  {
    template: true,
    user: 2,
    type: 'out',
    text: '',
    time: 'Just now',
  },
  {
    template: true,
    user: 4,
    type: 'in',
    text: 'Right before vacation season we have the next Big Deal for you.',
    time: 'Just now',
  },
]

export interface UserInfoModel {
  initials?: {label: string; state: 'warning' | 'danger' | 'primary' | 'success' | 'info'}
  nome_medium: string
  foto?: string
  nome_emite: string
  mediunidade: string
  templo_origem: string
  dt_ingresso: Date
  online: boolean
}

const defaultUserInfos: Array<UserInfoModel> = [
  {
    nome_medium: 'Emma Smith',
    foto: 'fotos/300-6.jpg',
    nome_emite: 'Emma',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2014-08-01'),
    online: false,
  },
  {
    nome_medium: 'Melody Macy',
    initials: {label: 'M', state: 'danger'},
    nome_emite: 'Melody',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2014-03-11'),
    online: true,
  },
  {
    nome_medium: 'Max Smith',
    foto: 'fotos/300-1.jpg',
    nome_emite: 'Max',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2012-05-01'),
    online: false,
  },
  {
    nome_medium: 'Sean Bean',
    foto: 'fotos/300-5.jpg',
    nome_emite: 'Sean',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2014-03-01'),
    online: false,
  },
  {
    nome_medium: 'Brian Cox',
    foto: 'fotos/300-25.jpg',
    nome_emite: 'Brian',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2004-03-01'),
    online: false,
  },
  {
    nome_medium: 'Mikaela Collins',
    initials: {label: 'M', state: 'warning'},
    nome_emite: 'Mikaela',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2000-03-01'),
    online: true,
  },
  {
    nome_medium: 'Francis Mitcham',
    foto: 'fotos/300-9.jpg',
    nome_emite: 'Francis',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('1988-03-01'),
    online: false,
  },

  {
    nome_medium: 'Olivia Wild',
    initials: {label: 'O', state: 'danger'},
    nome_emite: 'Olivia',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('1987-03-01'),
    online: true,
  },
  {
    nome_medium: 'Neil Owen',
    initials: {label: 'N', state: 'primary'},
    nome_emite: 'Neil',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('1999-03-01'),
    online: true,
  },
  {
    nome_medium: 'Dan Wilson',
    foto: 'fotos/300-23.jpg',
    nome_emite: 'Dan',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2010-03-01'),
    online: false,
  },
  {
    nome_medium: 'Emma Bold',
    initials: {label: 'E', state: 'danger'},
    nome_emite: 'Emma',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2014-09-01'),
    online: true,
  },
  {
    nome_medium: 'Ana Crown',
    foto: 'fotos/300-12.jpg',
    nome_emite: 'Ana Crown',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2004-02-01'),
    online: false,
  },
  {
    nome_medium: 'Robert Doe',
    initials: {label: 'A', state: 'info'},
    nome_emite: 'Robert',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2010-03-01'),
    online: true,
  },
  {
    nome_medium: 'John Miller',
    foto: 'fotos/300-13.jpg',
    nome_emite: 'John',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2012-03-01'),
    online: false,
  },
  {
    nome_medium: 'Lucy Kunic',
    initials: {label: 'L', state: 'success'},
    nome_emite: 'Lucy',
    mediunidade: 'Apará',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2004-03-11'),
    online: true,
  },
  {
    nome_medium: 'Ethan Wilder',
    foto: 'fotos/300-21.jpg',
    nome_emite: 'Ethan',
    mediunidade: 'Doutrinador',
    templo_origem: 'Templo Mãe',
    dt_ingresso: new Date('2016-05-23'),
    online: true,
  },
]

const messageFromClient: MessageModel = {
  user: 4,
  type: 'in',
  text: 'Thank you for your awesome support!',
  time: 'Just now',
}

export interface AlertModel {
  title: string
  description: string
  time: string
  icon: string
  state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}

const defaultAlerts: Array<AlertModel> = [
  {
    title: 'Project Alice',
    description: 'Phase 1 development',
    time: '1 hr',
    icon: 'technology-2',
    state: 'primary',
  },
  {
    title: 'HR Confidential',
    description: 'Confidential staff documents',
    time: '2 hrs',
    icon: 'information-5',
    state: 'danger',
  },
  {
    title: 'Company HR',
    description: 'Corporeate staff profiles',
    time: '5 hrs',
    icon: 'map001',
    state: 'warning',
  },
  {
    title: 'Project Red',
    description: 'New frontend admin theme',
    time: '2 days',
    icon: 'cloud-change',
    state: 'success',
  },
  {
    title: 'Project Breafing',
    description: 'Product launch status update',
    time: '21 Jan',
    icon: 'compass',
    state: 'primary',
  },
  {
    title: 'Banner Assets',
    description: 'Collection of banner images',
    time: '21 Jan',
    icon: 'graph-3',
    state: 'info',
  },
  {
    title: 'Icon Assets',
    description: 'Collection of SVG icons',
    time: '20 March',
    icon: 'color-swatch',
    state: 'warning',
  },
]

export interface AlertModel1 {
  title: string
  description: string
  time: string
  icon: string
  state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}



export interface LogModel {
  code: string
  state: 'success' | 'danger' | 'warning'
  message: string
  time: string
}

const defaultLogs: Array<LogModel> = [
  {code: '200 OK', state: 'success', message: 'New order', time: 'Just now'},
  {code: '500 ERR', state: 'danger', message: 'New customer', time: '2 hrs'},
  {code: '200 OK', state: 'success', message: 'Payment process', time: '5 hrs'},
  {code: '300 WRN', state: 'warning', message: 'Search query', time: '2 days'},
  {code: '200 OK', state: 'success', message: 'API connection', time: '1 week'},
  {code: '200 OK', state: 'success', message: 'Database restore', time: 'Mar 5'},
  {code: '300 WRN', state: 'warning', message: 'System update', time: 'May 15'},
  {code: '300 WRN', state: 'warning', message: 'Server OS update', time: 'Apr 3'},
  {code: '300 WRN', state: 'warning', message: 'API rollback', time: 'Jun 30'},
  {code: '500 ERR', state: 'danger', message: 'Refund process', time: 'Jul 10'},
  {code: '500 ERR', state: 'danger', message: 'Withdrawal process', time: 'Sep 10'},
  {code: '500 ERR', state: 'danger', message: 'Mail tasks', time: 'Dec 10'},
]

export {defaultMessages, defaultUserInfos, defaultAlerts,  defaultLogs, messageFromClient}
